<ng-container *ngIf="error">
    <div class="row mt-60">
        <div class="col-12">
            <div class="alert alert-danger font-size-16">{{ error }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!error">
    <div class="row mt-60">
        <div class="col-12">
            <h5 class="font-weight-bold mb-5 text-dark font-size-18">Institutes</h5>
        </div>
    </div>

    <div class="row">
        <div class="col-12 responsive-partial-overflow-swiper">
            <swiper [config]="responsivePartialOverflowConfig"
            (swiper)="onPartnerSwiper($event)"
            class="w-100"
            >
                <ng-template swiperSlide *ngIf="!loadedInstitutions">
                    <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                        'height': '300px',
                        'width': '100%'
                    }"></ngx-skeleton-loader>
                </ng-template>
                <ng-template swiperSlide *ngIf="!loadedInstitutions">
                    <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                        'height': '300px',
                        'width': '100%'
                    }"></ngx-skeleton-loader>
                </ng-template>
                <ng-template swiperSlide *ngFor="let institution of partnerInstitutions">
                    <div class="card shadow-xs mb-4 course-card w-100 h-100 cursor-pointer" (click)="loadInstitute(institution)">
                        <div class="card-img-top" [ngStyle]="{'background-image':'url(' + institution.thumbnail + ')'}">
                            <div class="card-img-inner-top">
                                <img loading="lazy" [src]="institution.icon" />
                                <h3>{{ institution.short_title }}</h3>
                                <h5>{{ institution.title }}</h5>
                            </div>
                        </div>
                        <div class="card-body">
                            <p [innerHTML]="institution.short_description | safeHtml"></p>
                        </div>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>

    <div class="row" style="margin-top: 10px;">
        <div class="col-12">
            <h5 class="font-weight-bold mb-5 text-dark" style="font-size: 18px;">National Qualifications</h5>
        </div>
    </div>

    <div class="row">
        <div class="col-12 responsive-partial-overflow-swiper">
            <swiper [config]="responsivePartialOverflowConfig"
            (swiper)="onNationalSwiper($event)"
            class="w-100"
            >
                <ng-template swiperSlide *ngIf="!loadedInstitutions">
                    <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                        'height': '300px',
                        'width': '100%'
                    }"></ngx-skeleton-loader>
                </ng-template>
                <ng-template swiperSlide *ngIf="!loadedInstitutions">
                    <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                        'height': '300px',
                        'width': '100%'
                    }"></ngx-skeleton-loader>
                </ng-template>
                <ng-template swiperSlide *ngFor="let qualification of nationalQualifications">
                    <div class="card shadow-xs mb-4 course-card w-100 h-100 cursor-pointer" (click)="loadInstitute(qualification)">
                        <div class="card-img-top" [ngStyle]="{'background-image':'url(' + qualification.thumbnail + ')'}">
                            <div class="card-img-inner-top">
                                <img loading="lazy" [src]="qualification.icon" />
                                <h3>{{ qualification.short_title }}</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <p [innerHTML]="qualification.short_description | safeHtml"></p>
                        </div>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>
</ng-container>